import { Text } from '@thanx/uikit/text'
import PopoverInfo from 'components/PopoverInfo'
import { STATUS_WARNING_COLOR } from 'constants/colors'
import { buildTranslate } from 'locales'

const t = buildTranslate('components.segment_state_badge')

interface SegmentStateBadgeProps {
  className?: string
}

// This is currently hard-coded to only handle the 'requires_approval' state.
// In the future, this component can be extended to handle other states.
const SegmentStateBadge = ({ className = '' }: SegmentStateBadgeProps) => {
  const containerClasses = `d-flex align-items-center${
    className ? ` ${className}` : ''
  }`

  return (
    <div className={containerClasses}>
      <div
        className="mr-1 border-round flex-shrink-0"
        style={{
          width: '8px',
          height: '8px',
          backgroundColor: STATUS_WARNING_COLOR,
        }}
      />

      <Text.SmallCaps3 color="grey60" className="mr-1">
        {t('label')}
      </Text.SmallCaps3>

      <PopoverInfo text={t('tooltip_content')} className="grey-50" />
    </div>
  )
}

export default SegmentStateBadge
